import { render, staticRenderFns } from "./FormulaLibraryDetail.vue?vue&type=template&id=1890766e&scoped=true"
import script from "./FormulaLibraryDetail.vue?vue&type=script&lang=js"
export * from "./FormulaLibraryDetail.vue?vue&type=script&lang=js"
import style0 from "./FormulaLibraryDetail.vue?vue&type=style&index=0&id=1890766e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890766e",
  null
  
)

export default component.exports